import Div from "@jumbo/shared/Div";
import { Form, Formik } from "formik";
import * as yup from "yup";
import { useLocation, useNavigate } from "react-router-dom";
import React, { useState } from "react";
import { Button, Typography } from "@mui/material";
import FormTextField from "app/components/InputField/FormTextField";
import { updateAddOns } from "app/services/apis/updateAddOns";
import Swal from "sweetalert2";
import { addAddOns } from "app/services/apis/addAddOns";
import { LoadingButton } from "@mui/lab";

export default function AddAddons() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { state } = useLocation();
  const [isSubmitting, setSubmitting] = useState(false);

  const supplier = {
    addons_name: state?.addons_name ? state?.addons_name : "",
    addons_rate: state?.addons_rate ? state?.addons_rate : "",
  };
  // console.log(state)
  const validationSchema = yup.object({
    addons_name: yup
      .string("Enter Item Name")
      .required("Item Name is required"),
    addons_rate: yup
      .string()
      .trim()
      .matches(/^\d+(\.\d+)?$/, "Rate must be a number")
      .required("Rate is required"),
  });
  const onUserSave = async (values) => {
    // console.log(values);
    setSubmitting(true);
    if (pathname == "/master/addons/edit") {
      const data = await updateAddOns(values, state.id);
      if (data?.status == 200) {
        Swal.fire({
          icon: "success",
          title: "AddOns Edited Successfully",
          text: "",
        });
        navigate("/dashboard/master/addons");
      } else {
        Swal.fire({
          icon: "error",
          title: data?.message,
          text: "",
        });
      }
    } else {
      const data = await addAddOns(values);
      if (data?.status == 200) {
        Swal.fire({
          icon: "success",
          title: "AddOns Added Successfully",
          text: "",
        });
        navigate("/dashboard/master/addons");
      } else {
        Swal.fire({
          icon: "error",
          title: data?.data?.message,
          text: "",
        });
      }
    }
    setSubmitting(false);
  };
  return (
    <Div sx={{ mt: -4 }}>
      <Typography variant="h1">
        {pathname == "/master/addons/add" ? "Add New Add Ons" : "Edit Add Ons"}
      </Typography>
      <Div>
        <Formik
          validateOnChange={true}
          initialValues={supplier}
          enableReinitialize={true}
          validationSchema={validationSchema}
          onSubmit={onUserSave}
        >
          {({ values }) => (
            <Form noValidate autoComplete="off">
              <Div sx={{ mt: 4 }}>
                <Div
                  sx={{
                    display: "flex",
                    width: "100%",
                    flexWrap: "wrap",
                    columnGap: 5,
                  }}
                >
                  <FormTextField name="addons_name" label="Item Name" />
                  <FormTextField name="addons_rate" label="Item Rate" />
                </Div>
                <Div
                  sx={{
                    width: "93.5%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 3,
                    mt: 3,
                  }}
                >
                  <Button
                    variant="outlined"
                    onClick={() => {
                      Swal.fire({
                        title: "Are you sure you want to cancel?",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonText: "Yes",
                        cancelButtonText: "No",
                      }).then((result) => {
                        if (result.isConfirmed) {
                          navigate("/dashboard/master/addons");
                        }
                      });
                    }}
                  >
                    Cancel
                  </Button>

                  <LoadingButton
                    variant="contained"
                    type="submit"
                    sx={{ width: "100px" }}
                    loading={isSubmitting}
                  >
                    Save
                  </LoadingButton>
                </Div>
              </Div>
            </Form>
          )}
        </Formik>
      </Div>
    </Div>
  );
}
